export default (context) => {
    if(context.main.length > 0) {
        let obj = context.main[context.main.length - 1]

        if(obj.type === 'video' && context.main.length > 0) {
            context.disabled.video = true
        }
    }

    let obj = context.main[context.main.length - 1]
    if((obj ? obj.type : false) === 'text' || context.main.length === 0) {
        context.disabled.text = true
    }
}